export const EVV_GEOLOCATION_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 10000,
  maximumAge: 0,
};

export const EVV_GEOLOCATION_ERRORS = {
  UNSUPPORTED: 'unsupported',
  FAILED: 'failed',
} as const;

export const EVV_TOKEN_KINDS = {
  START: 'start',
  END: 'end',
} as const;

export const EVV_TOKEN_STATUSES = {
  ACTIVE: 'active',
  CAPTURED: 'captured',
  EXPIRED: 'expired',
} as const;

export const EVV_STATUS_POLL_INTERVAL_MS = 2000;
